export const quiniela = {
  quinielaTitle: "Quiniela",
  quinielaHeroTitle: "World Cup Quiniela",
  quinielaSubtitle: "FIFA World Cup 2026",
  quinielaDescription: "Predict match outcomes from the World Cup and win prizes",
  quinielaPremiumLabel: "World Cup ticket",
  quinielaMiniBanner: "World Cup spin",
  quinielaBalance: "Balance",
  quinielaActiveRound: "Active round",
  quinielaMatches: "Matches",
  quinielaRounds: "Rounds",
  quinielaLeaderboard: "Standings",
  quinielaMyPredictions: "My Predictions",
  quinielaMyTickets: "My tickets",
  quinielaPlayTab: "Predict",
  quinielaTicketTab: "My ticket",
  quinielaRulesTab: "Rules",
  quinielaRulesTabHint: "Quick guide",
  quinielaTabsNav: "Quiniela primary navigation",
  quinielaHowToPlayCta: "How to play",
  quinielaChooseTournament: "Choose tournament",
  quinielaChooseRound: "Choose round",
  quinielaPlayNow: "Play now",
  quinielaViewTicket: "View ticket",
  quinielaReviewTicket: "Review ticket",
  quinielaReviewEyebrow: "Review",
  quinielaConfirmBet: "Confirm bet",
  quinielaEditPicks: "Edit picks",
  quinielaSubmit: "Submit Predictions",
  quinielaSubmitSuccess: "Predictions submitted successfully",
  quinielaSubmitError: "Failed to submit predictions",
  quinielaLoadError: "We could not load matches for this round.",
  quinielaRetry: "Retry",
  quinielaTicketConfirmed: "Ticket confirmed.",
  quinielaTicketConfirmedTitle: "Ticket confirmed",
  quinielaTicketId: "Ticket ID",
  quinielaTicketIdPending: "Generating",
  quinielaConfirmedAt: "Confirmed",
  quinielaDeadline: "Prediction deadline",
  quinielaEntryFee: "Entry fee",
  quinielaPrizePool: "Prize pool",
  quinielaCurrentBalance: "Current balance",
  quinielaBalanceAfter: "Balance after",
  quinielaPoints: "Points",
  quinielaRank: "Rank",
  quinielaHomeWin: "Home",
  quinielaDraw: "Draw",
  quinielaAwayWin: "Away",
  quinielaMatchDay: "Matchday",
  quinielaGroup: "Group",
  quinielaGroupStage: "Group Stage",
  quinielaRound32: "Round of 32",
  quinielaRound16: "Round of 16",
  quinielaQuarterFinals: "Quarter Finals",
  quinielaSemiFinals: "Semi Finals",
  quinielaThirdPlace: "Third Place",
  quinielaFinal: "Final",
  quinielaVs: "vs",
  quinielaPenalties: "pen",
  quinielaPrediction: "Prediction",
  quinielaResult: "Result",
  quinielaCorrect: "Correct",
  quinielaIncorrect: "Incorrect",
  quinielaPending: "Pending",
  quinielaRoundOpen: "Open",
  quinielaRoundLocked: "Locked",
  quinielaRoundScored: "Scored",
  quinielaRoundUpcoming: "Upcoming",
  quinielaRoundClosedTitle: "This round is already closed.",
  quinielaRoundClosedDescription: "You cannot edit or submit picks because this round is closed.",
  quinielaNoRounds: "No rounds available",
  quinielaNoTicketYet: "You do not have a loaded ticket yet.",
  quinielaNoTicketDescription: "Complete your 1X2 picks and review your ticket before confirming.",
  quinielaStartTicket: "Start ticket",
  quinielaAlreadySubmitted: "You already submitted predictions for this round",
  quinielaSelectAll: "You must select a prediction for every match",
  quinielaMissingPicks: "You still have {{count}} matches to complete.",
  quinielaMissingPicksShort: "{{count}} picks left",
  quinielaTabReady: "Ready to submit",
  quinielaTabWaiting: "No active round",
  quinielaTabLocked: "Picks locked",
  quinielaTabPendingCount: "{{count}} left",
  quinielaTabTicketDraft: "Draft",
  quinielaTabTicketEmpty: "Empty",
  quinielaTabTicketConfirmed: "Confirmed",
  quinielaTabLeaderboardLive: "Competition live",
  quinielaTabLeaderboardReady: "Results ready",
  quinielaTournamentLeaderboard: "Overall Leaderboard",
  quinielaRoundLeaderboard: "Round Leaderboard",
  quinielaFree: "Free",
  quinielaUser: "User",
  quinielaTotalPoints: "Total Points",
  quinielaMyPosition: "My position",
  quinielaYourPick: "Your pick",
  quinielaPredictionsLocked: "Predictions locked.",
  quinielaInsufficientBalanceTitle: "Insufficient balance.",
  quinielaInsufficientBalanceDescription: "You need more balance to confirm this ticket.",

  quinielaHowToPlayTitle: "How to play the Quiniela?",
  quinielaHowToPlayStep1Title: "1. Pick a round",
  quinielaHowToPlayStep1Desc:
    "Select an open matchday from the FIFA World Cup 2026. Each round groups several matches played on the same day.",
  quinielaHowToPlayStep2Title: "2. Predict the outcomes",
  quinielaHowToPlayStep2Desc:
    "For each match, select: 1 (home win), X (draw), or 2 (away win). You must predict every match in the round.",
  quinielaHowToPlayStep3Title: "3. Pay and confirm",
  quinielaHowToPlayStep3Desc:
    "If the round has an entry fee, it will be debited from your game balance when you submit your predictions. Predictions cannot be changed after submission.",
  quinielaHowToPlayStep4Title: "4. Earn points",
  quinielaHowToPlayStep4Desc:
    "Each correct prediction is worth 1 point. Once all matches in the round are finished, points are calculated automatically.",
  quinielaHowToPlayStep5Title: "5. Check the leaderboard",
  quinielaHowToPlayStep5Desc:
    "View the round leaderboard and the overall tournament standings. Top predictors win prizes from the pool!",
  quinielaHowToPlayNote:
    "Predictions close before the first match of each round kicks off. Make sure to submit your picks on time.",
};
